'use strict'
if (process.env.NODE_ENV === 'production') {
  module.exports = require('./redux-toolkit.cjs.production.min.js')
} else {
  module.exports = require('./redux-toolkit.cjs.development.js')
}


//////////////////
// WEBPACK FOOTER
// ./~/@reduxjs/toolkit/dist/index.js
// module id = 560
// module chunks = 0